import React from "react";
import { LEADER_KEY } from "./actions/StageActions";

interface LeaderModeIndicatorProps {
  isActive: boolean;
}

export const LeaderModeIndicator: React.FC<LeaderModeIndicatorProps> = ({
  isActive,
}) => {
  if (!isActive) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-60 animate-pulse">
      <div className="bg-cyan-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2">
        <kbd className="px-2 py-1 bg-cyan-600 rounded-sm text-sm font-mono">
          {LEADER_KEY}
        </kbd>
        <span className="text-sm font-medium">Leader mode active - press a key</span>
      </div>
    </div>
  );
};
